<template>
  <!-- Main Sidebar Container -->
  <aside class="main-sidebar sidebar-dark-primary elevation-4">
    <!-- Brand Logo -->
    <a href="index3.html" class="brand-link" style="opacity: 0">
      <img
        src="dist/img/AdminLTELogo.png"
        alt="AdminLTE Logo"
        class="brand-image img-circle elevation-3"
        style="opacity: 0.8"
      />
      <span class="brand-text font-weight-light">AdminLTE 3</span>
    </a>

    <!-- Sidebar -->
    <div class="sidebar">
      <!-- Sidebar Menu -->
      <nav>
        <ul
          class="nav nav-pills nav-sidebar flex-column"
          data-widget="treeview"
          role="menu"
        >
          <MenuItem
            v-for="(item, index) in menuItems"
            :title="item.title"
            :icon-class="item.icon"
            :iconComponent="item.componentIcon"
            :children="item.children"
            :is-open="menuOpen"
            @handleClickMenu="toggleMenu"
            :is-collapsing="item.collapse"
            :path="item.path"
            :permission="item.permission"
            :key="item.path || index.toString()"
          />
        </ul>
      </nav>

      <!-- /.sidebar-menu -->
    </div>
    <!-- /.sidebar -->
  </aside>
</template>
<script>
import { PERMISSION } from "@/constants/permission.constant";
import { mapActions, mapGetters } from "vuex";
import MenuItem from "./MenuItem.vue";

export default {
  name: "AppSideBar",
  props: { menuItems: [] },
  components: { MenuItem },
  data() {
    return {
      menuOpen: "",
      permissionsList: [],
      PERMISSION,
    };
  },
  computed: {
    ...mapGetters("menuStore", ["activeMenuItem"]),
    isActive() {
      return (routeName) => this.activeMenuItem === routeName;
    },
  },
  methods: {
    ...mapActions("menuStore", ["setActiveMenuItem"]),
    setActive(menuItem) {
      this.setActiveMenuItem(menuItem);
    },
    toggleMenu(title) {},

    getAllUlAndLiElements(element) {
      let elements = [];

      function traverse(node) {
        if (node.nodeName === "UL" || node.nodeName === "LI") {
          elements.push(node);
        }

        for (let child of node.children) {
          traverse(child);
        }
      }

      traverse(element);
      return elements;
    },
    async fetchLatestData() {
      await this.$store.dispatch("userPermission/getPermissionsUsers");
    },
    activeMenu() {
      const route = this.$route.path;
      const startEl = this.$refs["sidebar"].querySelector("ul");

      const pathStr = route.replace(/^\//, "");
      const paths = pathStr.split("/") || [];
      const parentOpen = startEl?.querySelector(
        `li.nav-item a[href="/${paths[0]}"]`
      );

      startEl.querySelectorAll("li.nav-item").forEach((el) => {
        el?.classList?.remove("menu-is-opening", "menu-open");
      });

      const elementChild = parentOpen
        ?.closest("li.nav-item")
        ?.classList?.add("menu-is-opening", "menu-open");

      parentOpen?.querySelector(
        `ul li.nav-item a[href="/${paths[0]}/${paths[1]}"]`
      );
    },
  },
  watch: {
    "$route.name"(newRoute) {
      this.setActiveMenuItem(newRoute);
    },
  },
  mounted() {
    this.setActiveMenuItem(this.$route.name);
  },
  created() {
    this.fetchLatestData().then((d) => {});
  },
};
</script>
<style lang="scss"></style>
